export enum AttachmentType {
    AVATAR = 'AVATAR',
    COVER = 'COVER',
    DESIGN_BOARD = 'DESIGN_BOARD',
    FLOOR_PLAN = 'FLOOR_PLAN',
    SHOWCASE = 'SHOWCASE',
}
